<template>
    <div class="article_sidebar">
        <div class="article_for_stat_header"><p>{{Lang.get('js.popular')}}</p></div>

        <div class="row no-gutters">
            <ul class="menu-sidebar w-100">
                <li :class="!currentCategory ? 'active' : ''">
                    <span @click="filterData()">
                        {{Lang.get('js.all')}}
                    </span>
                </li>
                <li v-if="categories"
                    v-for="(cat, key) in categories"
                    :key="'cat_' + key"
                    @click="filterData(cat.id)"
                    :class="currentCategory === cat.id ? 'active' : ''">
                    <span>
                        {{cat.name}}
                    </span>
                </li>
            </ul>
        </div>

        <div class="article_for_stat row">
            <div class="col-6 col-md-12 sidebar-item"
                 v-if="items"
                 v-for="(item, key) in items"
                 :key="'item_' + key">
                <div class="row align-items-center">

                    <div class="blog_block" >
                        <div class="row-for-sidebar">
                            <div class="image image-for-sidebar">
                                <a :href="item.url" :title="item.name">
                                    <div class="blog_flowers">
                                        <img class="b-lazy img-fluid"
                                             :src="item.img"
                                             :alt="item.name">
                                    </div>
                                </a>
                            </div>
                            <div class="dop-block">
                                <div class="category">
                                    <span v-if="item.category_name">{{item.category_name}}</span>
                                </div>
                                <div class="views">
                                    <div class="views-count">
                                        <span>{{item.views ? item.views : 0}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center title-for-sidebar">
                                <a class="blog_down_text" :href="'/' + item.url"
                                   :title="item.name">{{item.name}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'popular-article',
        props: {
            categories: {
                required: true
            },
            articles: {
                required: true
            }
        },
        data() {
            return {
                Lang,
                items: [],
                currentCategory: '',
            }
        },
        methods: {
            filterData(id = null) {
                if (!id) {
                    this.currentCategory = '';
                    this.items = this.articles;
                    return
                }
                this.currentCategory = id;
                this.items = this.articles.filter(el => el.category_id === id);
            }
        },
        mounted() {
            this.filterData();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/elements/PopularArticle.vue